/* eslint-disable react-hooks/exhaustive-deps */
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Chat, ChatApp } from "../../../Constant";
import { useAppDispatch } from "../../../Redux-Toolkit/Hooks";
import axios from "axios";
import { ChatApi, ChatMemberApi } from "../../../api";
import { useEffect } from "react";
import { setAllMembers, setChats } from "../../../Redux-Toolkit/Reducers/ChatSlice";
import ChatStatus from "../Common/ChatStatus";
import Chatting from "./Chatting";
import { toast } from "react-toastify";

const ChatAppContainer = () => {
  const dispatch = useAppDispatch();
  const getChatMembersData = async () => {
    try {
      await axios.get(ChatMemberApi).then((resp) => {
        dispatch(setAllMembers(resp.data));
      });
    } catch (error) {
      toast.error("error" + error);
    }
  };

  const getChatData = async () => {
    try {
      await axios.get(ChatApi).then((resp) => {
        dispatch(setChats(resp.data.data));
      });
    } catch (error) {
      toast.error("error" + error);
    }
  };

  useEffect(() => {
    getChatData();
    getChatMembersData();
  }, []);

  return (
    <>
      <Breadcrumbs pageTitle={ChatApp} parent={Chat} title={ChatApp} />
      <Container fluid>
        <Row>
          <Col sm="12" className="call-chat-sidebar">
            <Card>
              <CardBody className="chat-body">
                <ChatStatus />
              </CardBody>
            </Card>
          </Col>
          <Col className="call-chat-body">
            <Card>
              <CardBody className="p-0">
                <Chatting />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ChatAppContainer;
